import type { CSSProperties } from 'react';
import type { ThemeRegistry } from '@classy/theme-sdk';
import loginBg from '../../../../assets/auth/login-bg.png';
import styles from './SetupNotice.module.css';

export interface SetupNoticeProps {
  /** Kept in the prop bag for API symmetry with the previous version
   *  (and in case we want to surface theme names here later) — unused
   *  today now that the auth bg is fixed. */
  registry?: ThemeRegistry;
}

/**
 * Pre-auth "this build isn't configured" screen. Renders the fixed
 * auth-surface bg (no theme rotation, no mascot) so the page feels
 * deliberate rather than randomly themed.
 */
export function SetupNotice(_props: SetupNoticeProps) {
  return (
    <div
      className={styles.screen}
      style={{ '--login-bg': `url(${loginBg})` } as CSSProperties}
      data-testid="setup-notice"
    >
      <div className={styles.tint} aria-hidden="true" />
      <div className={styles.stack}>
        <section className={styles.card} aria-labelledby="setup-title">
          <h1 id="setup-title" className={styles.title}>
            Setup needed
          </h1>
          <p className={styles.subtitle}>Sign-in isn&apos;t wired up for this dev build.</p>
          <p className={styles.body}>
            To use this build, either turn on the dev-auth bypass or point it at a real Microsoft
            app registration.
          </p>
          <ul className={styles.steps} aria-label="Setup options">
            <li>
              For local-only work, set <span className={styles.code}>VITE_DEV_AUTH=1</span> and{' '}
              <span className={styles.code}>CLASSY_DEV_AUTH=1</span> in{' '}
              <span className={styles.code}>.env.local</span>, then restart{' '}
              <span className={styles.code}>pnpm dev</span>.
            </li>
            <li>
              For real sign-in, set <span className={styles.code}>VITE_MSAL_CLIENT_ID</span> in{' '}
              <span className={styles.code}>.env.local</span> to your Azure app registration&apos;s
              client ID and restart.
            </li>
          </ul>
          <p className={styles.fineprint}>
            See <span className={styles.code}>docs/LOCAL_DEV.md</span> for the full setup
            walkthrough.
          </p>
        </section>
      </div>
    </div>
  );
}
